import React, { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import EditarComponente from "./EditarComponente";
import ClasificacionComponente from "./ClasificacionComponente";
import EfectosPropios from "./EfectosPropios";
import CheckRole from "../CheckRole.js";
import { DecryptData } from "../DatosEncriptados/EncryptedFunctions";
import AADService from "../funcionesAuth.js";

const MainEditarComponente = (props) => {
  const idCompania = localStorage.getItem("idcompania");
  const [valueWindow, setValueWindow] = useState(0);
  const ismodule = props.location.state ? props.location.state.value : 1;
  const check = new CheckRole("/MainEditarComponente");
  const [opcionesGenerales, setOpcionesGenerales] = React.useState([]);
  const AzureADService = new AADService();
  const token = AzureADService.getToken();

  useEffect(() => {
    const fetchUsuario = async () => {
      const result = await fetch(
        process.env.REACT_APP_API_URL +
          "usuarios/menu/" +
          localStorage.getItem("usuario") +
          "/",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
          },
        }
      );
      const encryptedUser = await result.json();
      const decryptedUser = DecryptData(encryptedUser);
      let usuario = JSON.parse(decryptedUser);
      let opciones = [];
      let permisos = [];
      for (let i = 0; i < usuario.length; i++) {
        permisos = usuario[i].permisos.split(";");
        opciones.push({ opcion: usuario[i].url_opcion, permisos: permisos });
      }
      setOpcionesGenerales(opciones);
    };
    fetchUsuario();
    setValueWindow(0);
  }, [idCompania]);

  const handleChange = (event, newValue) => {
    if (idCompania === "1") {
      setValueWindow(newValue);
    }
  };

  // const props = {
  //     "pathname": "/EditarComponente",
  //     "state": {
  //         "value": 1
  //     },
  //     "search": "",
  //     "hash": "",
  //     "key": "xj0vk3"
  // }

  return (
    <div>
      <AppBar
        position="static"
        style={{ backgroundColor: "#2c2a29", color: "#ffffff" }}
      >
        <Tabs value={valueWindow} onChange={handleChange}>
          <Tab
            label="Detalle"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
          {idCompania === "1" && ismodule == 1 ? (
            <Tab
              label="Clasificación"
              style={{ color: "#ffffff", padding: "3px 7px 3px" }}
            />
          ) : (
            <Tab
              label="Clasificación"
              style={{ color: "#ffffff", padding: "3px 7px 3px" }}
              disabled
            />
          )}
          <Tab
            label="Autoevaluación"
            style={{ color: "#ffffff", padding: "3px 7px 3px" }}
          />
        </Tabs>
      </AppBar>
      {valueWindow === 0 && <EditarComponente ismodule={ismodule} />}
      {valueWindow === 1 && idCompania === "1" && ismodule == 1 && check.checkPermits(opcionesGenerales, "PUT") && (
        <ClasificacionComponente />
      )}
      {valueWindow === 2 && check.checkPermits(opcionesGenerales, "PUT") && <EfectosPropios />}
    </div>
    // onClick={() => window.location.href = '/EfectosPropios'}
  );
};

export default MainEditarComponente;
